export const contactFormConfig = {
  en: {
    heading: "Contact Form",
    pageTitle: "Contact Kohler Vietnam - Send Us a Message | Kohler",
    pageDescription: "Send a message to the KOHLER Vietnam team for product questions, showroom information, or support, and our team will respond promptly. Discover more at Kohler.",
    privacyPolicy: "Kohler Privacy Policy",
    url: "https://www.kohlercompany.com/privacy/",
    submit: "Submit",
    submitting: "Submitting",
    thankYouMessage:
      "Thank you for your enquiry! We will get back to you soon.",
    selectList: "Select",
    capchaErrorMessage: "Please verify the captcha",
    capchaVerificationMessage: "Captcha verification failed",
    tryAgainMessage: "Something went wrong. Please try again.",
    verifyCaptchaMessage: "Please verify the captcha",
    formFields: [
      {
        type: "select",
        name: "request_type",
        label: "Select Request Type",
        options: [
          "After sales service",
          "Commercial enquire",
          "Product information",
          "Promotion",
          "Others",
        ],
        required: true,
        message: "Please select a request type",
      },
      {
        type: "text",
        name: "first_name",
        label: "First Name",
        required: true,
      },
      {
        type: "text",
        name: "last_name",
        label: "Last Name",
        required: true,
      },
      {
        type: "email",
        name: "email",
        label: "Email Address",
        required: true,
      },
      {
        type: "text",
        name: "phone",
        label: "Mobile Number",
        required: true,
      },
      {
        type: "textarea",
        name: "message",
        label: "Please Describe Your Request",
        required: true,
      },
    ],
  },
  vn: {
    heading: "Biểu mẫu Liên hệ",
    pageTitle: "Liên Hệ Kohler Việt Nam - Gửi Yêu Cầu | Kohler",
    pageDescription: "Gửi yêu cầu liên hệ đến đội ngũ KOHLER Việt Nam để được tư vấn sản phẩm, thông tin showroom và hỗ trợ sau bán hàng. Tìm hiểu ngay tại Kohler.",
    privacyPolicy: "Kohler Privacy Policy",
    url: "https://www.kohlercompany.com/privacy/",
    submit: "Gửi đi ",
    submitting: "Đang gửi...",
    thankYouMessage:
      "Cảm ơn bạn đã gửi yêu cầu! Chúng tôi sẽ liên hệ lại với bạn sớm.",
    selectList: "Chọn",
    capchaErrorMessage: "Vui lòng xác minh hình ảnh xác thực",
    capchaVerificationMessage: "Xác minh captcha thất bại",
    tryAgainMessage: "Đã xảy ra lỗi. Vui lòng thử lại.",
    verifyCaptchaMessage: "Vui lòng xác minh hình ảnh xác thực",
    formFields: [
      {
        type: "select",
        name: "request_type",
        label: "Chọn loại yêu cầu",
        options: [
          "Dịch vụ hậu mãi",
          "Yêu cầu thương mại",
          "Thông tin sản phẩm",
          "Khuyến mãi",
          "Khác",
        ],
        required: true,
        message: "Vui lòng chọn loại yêu cầu",
      },
      {
        type: "text",
        name: "first_name",
        label: "Họ",
        required: true,
      },
      {
        type: "text",
        name: "last_name",
        label: "Tên",
        required: true,
      },
      {
        type: "email",
        name: "email",
        label: "Địa chỉ Email",
        required: true,
        message: "Vui lòng nhập địa chỉ email hợp lệ",
      },
      {
        type: "text",
        name: "phone",
        label: "Số điện thoại",
        required: true,
      },
      {
        type: "textarea",
        name: "message",
        label: "Vui lòng nhập yêu cầu của bạn",
        required: true,
        message: "Vui lòng nhập bình luận của bạn",
      },
    ],
  },
};
